import { render, staticRenderFns } from "./AssistentRow.vue?vue&type=template&id=2889e3cc&scoped=true&"
import script from "./AssistentRow.vue?vue&type=script&lang=js&"
export * from "./AssistentRow.vue?vue&type=script&lang=js&"
import style0 from "./AssistentRow.vue?vue&type=style&index=0&id=2889e3cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2889e3cc",
  null
  
)

export default component.exports